import { AppStore } from 'stores/AppStore';

export const headerHeightDesktop = 100;
export const headerHeightDesktopSm = 80;
export const headerHeightMobile = 75;
export const headerHeightMobileSm = 55;

const links = {
  insideKit: { href: '/inside-kit', label: `Inside ${process.env.BRAND_NAME}` },
  faq: { href: '/faqs', label: 'FAQs' },
  contactUs: { href: '/contact-us', label: 'Contact us' },
  termsAndCondition: {
    href: '/terms-and-conditions',
    label: 'Terms and conditions',
    lowPriority: true,
  },
  privacyPolicy: {
    href: '/privacy-policy',
    label: 'Privacy policy',
    lowPriority: true,
  },
  infoCenter: { href: '/info-center', label: 'Info Centre' },
};

const dipUtiLinks = {
  sidebarLinks: [links.insideKit, links.faq, links.infoCenter, links.contactUs],
  navbarLinks: [links.insideKit, links.faq, links.infoCenter, links.contactUs],
};

export function getNavbarLinks() {
  if (AppStore.isDipUti) {
    return dipUtiLinks;
  }

  return {
    sidebarLinks: [
      links.insideKit,
      links.faq,
      links.contactUs,
      links.privacyPolicy,
      links.termsAndCondition,
    ],
    navbarLinks: [links.insideKit, links.faq, links.contactUs],
  };
}
